module.exports = __webpack_public_path__ + "public/img/agile_2.206714c5.png";